<app-main-navigation>
  <!-- Router Outlet -->
  <router-outlet></router-outlet>
</app-main-navigation>
